// This doesn't seem to have Murdoch/Bootstrap styling. Is it actively used??
<template>
   <div class="search-bar">
      <input
         id="search"
         type="search"
         name="input"
         :placeholder="placeHolder"
         v-model="message"
         autocomplete="off"
         class="input"
      ><button
         type="button"
         name="search"
         :value="message"
         v-on="buttonListeners"
         class="button"
      >Search</button>
   </div>
</template>

<script>
   export default {
      //pass what the placeholder will be for the input string
      props: {
         placeHolder:{
            type: String,
            required: false,
         },
         value:{
            type: String,
            required: false,
         },
      },
      data: function(){
         return {
            //data holder for the message inside the text input
            message: "",
         }
      },
      computed: {
         //handles the event of the button being clicked, which grabs the data from the search bar and outputs it
         buttonListeners: function(){
            var vm = this;
            return Object.assign({},
            this.$listeners,
            {
               click: function (event){
                  vm.$emit('click', event.target.value);
               },
            })
         },
      },
      watch: {
         value : function(){
            this.message = this.value;
         }
      }
   }
</script>

